import React from "react";
import Banner from "../Components/Banner/Banner";
import CoinTable from "../Components/CoinTable/CoinTable";

function HomePage() {
  return (
    <>
      <Banner />
      <CoinTable />
    </>
  );
}

export default HomePage;
